import React, { Component } from "react";
import { connect } from "react-redux";
import { convertSize } from "../constants";

class ConditionalComponent extends Component {
  shouldRender = () => {
    const {
      field: { size, type: selectedType },
      conditions: { minX, minY, maxX, fieldType } = {},
    } = this.props;
    const { x, y } = convertSize(size);
    if (minX && x < minX) {
      return false;
    }
    if (minY && y < minY) {
      return false;
    }
    if (maxX && x > maxX) {
      return false;
    }
    if (fieldType && selectedType !== fieldType) {
      return false;
    }
    return true;
  };

  render() {
    const { children, component: Component } = this.props;
    if (!this.shouldRender()) {
      return null;
    }
    if (Component) return <Component />;
    return children;
  }
}

const mapState = ({ field }) => ({ field });
ConditionalComponent = connect(mapState)(ConditionalComponent);
export default ConditionalComponent;
